module.exports = __webpack_public_path__ + "static/media/advantage2.77d2abc4.png";